import { isNullOrUndefined, withNewOptionalValue } from '@weft/utils';
import { createElement } from 'react';
import type { ToastOptions } from 'react-toastify';
import { toast } from 'react-toastify';
import { DEFAULT_TOAST_OPTIONS, DEFAULT_ERROR_DELAY, DEFAULT_SUCCESS_DELAY } from './vy-toast-consts';
import type { ToastPromiseStateOptions } from './vy-toast-types';
import type { NotificationPromiseState } from './vy-toast-types/notification-promise-state';
import type { VyToastFromPromiseRenderOptions } from './vy-toast-types/vy-toast-from-promise-render-options';
import { VyToastIcon } from './vy-toasts-components';

export function toastFromPromise<Response>(promise: Promise<Response>, { error, pending, success }: VyToastFromPromiseRenderOptions) {
  return toast.promise(
    promise,
    { 
      pending: addPromiseStateToOptions({ render: pending, options: DEFAULT_TOAST_OPTIONS }),
      success: addPromiseStateToOptions({ render: success, options: DEFAULT_TOAST_OPTIONS, delay: DEFAULT_SUCCESS_DELAY, toastType: 'success' }),
      error: addPromiseStateToOptions({ render: error, options: DEFAULT_TOAST_OPTIONS, delay: DEFAULT_ERROR_DELAY, toastType: 'error' }),
    },
  );
}

function addPromiseStateToOptions<PromiseState extends NotificationPromiseState>({ delay, toastType, render, options }: ToastPromiseStateOptions<PromiseState>) {
  if (isNullOrUndefined(render)) {
    return undefined;
  }

  const icon: ToastOptions['icon'] = withNewOptionalValue(
    toastType,
    (type) => (
      iconProps => createElement(VyToastIcon, { ...iconProps, type })
    ),
  );

  return {
    ...options,
    render,
    icon,
    delay,
  };
}